import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoaderComponent } from './loader.component';
import { LoaderInterceptor } from './loader.interceptor';
import { LoaderService } from './loader.service';

const COMPONENTS = [LoaderComponent];
const SERVICES = [LoaderService];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [HttpClient],
      },
    }),
  ],
  exports: [COMPONENTS],
  providers: [
    SERVICES,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
})
export class LoaderModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: LoaderModule,
      providers: SERVICES,
    };
  }
}
